import {type FC, useCallback} from 'react';

import {Logo} from '../../uikit/Logo';
import {reloadApp} from '../../utils/reloadApp';
import {Button} from '../NoResultsView/styles';
import * as S from './styles';

type Props = {
  error: Error;
};

export const DefaultErrorFallback: FC<Props> = ({error}) => {
  const onReload = useCallback(() => {
    reloadApp();
  }, []);

  return (
    <S.Container>
      <Logo size={50} variant="text" />
      <S.Title>Whoops! Something went wrong!</S.Title>
      <S.Description>{error.message}</S.Description>
      <Button.V2 onClick={onReload} size="la">
        Reload
      </Button.V2>
    </S.Container>
  );
};
